export default {
  VOUCHER: 'voucher',
  ELIGIBILITY_LIST: 'eligibility_list',
  ELIGIBLE_TOKEN: 'eligible_token',
}
